import { connect } from 'react-redux'
import Applied_Roles from 'modules/Applied_Roles/index'
import selector from 'modules/Applied_Roles/selectors'
import { getAppliedRoleList,getAppliedRoleMetrics } from 'modules/Applied_Roles/actions'

const mapStateToProps = state => ({
    appliedRoleList: selector.getAppliedRoleList(state),
    appliedRoleMetrics: selector.getAppliedRoleMetrics(state)
})

const mapDispatchToProps = {
    getAppliedRoleList,
    getAppliedRoleMetrics
}

export default connect(mapStateToProps, mapDispatchToProps)(Applied_Roles)
